export default function TextArea({ id, value = '', onChange, numRows = 4, placeholder = '', testId = '', name = '' }) {
    return (
        <textarea
            id={id}
            name={name}
            data-testid={testId}
            value={value}
            onChange={onChange}
            rows={numRows}
            className="resize-none block p-4 max-w-full text-base border-none bg-white rounded-3xl ring-1 ring-inset ring-gray-300 focus-within:outline-none focus-within:ring-2 focus-within:ring-secondary-blue hover:ring-secondary-blue"
            placeholder={placeholder}>
        </textarea>
    )
}